import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

// 1. Kasih fallback OR {} biar nggak error kalau null

const randomStr = (len) => Math.random().toString(36).substring(2, 2 + len);
const code = JSON.parse(localStorage.getItem('auth'))?.BoUser || {};
const rawData = `${randomStr(5)}_acid=${code.useruid}:bo_${randomStr(5)}`;
const token = btoa(rawData);

export const echo = new Echo({
    broadcaster: 'reverb',
    key: import.meta.env.VITE_REVERB_APP_KEY || 'frmsctbpki',
    wsHost: import.meta.env.VITE_REVERB_HOST || '127.0.0.1',
    wsPort: import.meta.env.VITE_REVERB_PORT || 8080,
    wssPort: import.meta.env.VITE_REVERB_PORT || 8080,
    forceTLS: (import.meta.env.VITE_REVERB_SCHEME || 'http') === 'https',
    enabledTransports: ['ws', 'wss'],

    authEndpoint: import.meta.env.VITE_REVERB_URL||'https://dev-w-api.farmsco.co.id/api/broadcasting/auth',
    // authEndpoint: 'http://localhost/farmsco-toolbox/api/public/api/broadcasting/auth',
    auth: {
        headers: {
            // 2. Masukin token yang udah aman tadi
            Authorization:'Bearer '+ token
        }
    }
});
